module.exports = __webpack_public_path__ + "static/kobeGigi-f513a21770a94adc2a4d1e73cb91f400.jpg";